export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  director: string;
  cast: string[];
  year: number;
  rating: number;
  runtime: string;
  imageUrl: string;
  tags: string[];
  featured: boolean;
  publishDate: string;
}

export const articles: Article[] = [
  {
    id: '1',
    slug: 'the-handmaiden-review',
    title: '《小姐》：朴赞郁的欲望迷宫与女性觉醒',
    excerpt: '朴赞郁导演2016年力作，以精巧的三段式叙事结构，在殖民时代的朝鲜半岛背景下，讲述了一场关于欺骗、情欲与解放的华丽博弈。影片以其惊人的视觉美学和深刻的人性洞察，成为韩国伦理电影的巅峰之作。',
    content: `<p>《小姐》（The Handmaiden）是韩国导演朴赞郁于2016年推出的心理情欲惊悚片，改编自英国作家莎拉·沃特斯的小说《荆棘之城》。影片将故事背景从维多利亚时代的英国移植到日本殖民统治时期的朝鲜，呈现出一种独特的东亚美学风格。</p>

<h3>叙事结构：三段式的精巧布局</h3>
<p>影片分为三个章节，分别以南淑姬（金泰梨饰）、秀子小姐（金敏喜饰）和藤原伯爵（河正宇饰）的视角展开叙述。这种多视角的叙事手法让观众在每一章节中都能获得全新的认知，不断颠覆之前建立的理解。朴赞郁用这种结构巧妙地探讨了权力、欲望和欺骗的复杂关系。</p>

<h3>视觉美学：东西方交融的极致表达</h3>
<p>影片的美术设计堪称教科书级别。日式建筑与英式花园的结合、精致的和服与西式礼服的交替出现，创造出一个既熟悉又陌生的视觉世界。摄影师郑正勋的镜头语言克制而优雅，每一个画面都像是一幅精心构图的油画。</p>

<h3>女性主题：从客体到主体的觉醒</h3>
<p>《小姐》最令人赞叹之处在于其对女性意识的深刻表达。秀子小姐和南淑姬的关系从最初的欺骗与算计，逐渐演变为相互理解与情感连接。她们的觉醒不仅是对男性压迫的反抗，更是对自我身份的重新定义。影片结尾，两个女人选择挣脱束缚，追求属于自己的人生，这一结局充满力量。</p>

<h3>演员表现</h3>
<p>金敏喜凭借此片获得了包括青龙奖在内的多项最佳女主角奖。她将秀子小姐的脆弱、隐忍与最终的坚定诠释得入木三分。金泰梨饰演的南淑姬则展现出从市井小偷到真心爱人的细腻转变。河正宇的反派形象也摆脱了脸谱化，赋予了角色复杂的人性。</p>`,
    category: '禁忌爱情',
    categorySlug: 'forbidden-love',
    director: '朴赞郁',
    cast: ['金敏喜', '金泰梨', '河正宇', '赵震雄'],
    year: 2016,
    rating: 8.8,
    runtime: '145分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20period%20film%20cinematic%20scene%20with%20two%20women%20in%20traditional%20elegant%20attire%20standing%20in%20a%20grand%20Japanese-Korean%20mansion%20with%20cherry%20blossoms%2C%20soft%20natural%20lighting%2C%20artistic%20composition%2C%20film%20noir%20atmosphere%2C%20warm%20amber%20and%20cream%20tones%2C%20vintage%20aesthetic%2C%20editorial%20quality&width=800&height=500&seq=handmaiden-2016&orientation=landscape',
    tags: ['朴赞郁', '女性主题', '心理惊悚', '殖民时代', '改编'],
    featured: true,
    publishDate: '2024-10-15',
  },
  {
    id: '2',
    slug: 'burning-review',
    title: '《燃烧》：李沧东的存在主义悬疑诗篇',
    excerpt: '李沧东导演时隔八年的回归之作，改编自村上春树短篇小说《烧仓房》。影片以一场若即若离的三角关系为引子，展开对阶级分化、青年迷茫和存在意义的深刻追问。戛纳电影节场刊历史最高分3.8分。',
    content: `<p>《燃烧》（Burning）是韩国著名作家导演李沧东于2018年推出的作品，改编自村上春树的短篇小说《烧仓房》。影片入围第71届戛纳电影节主竞赛单元，获得了场刊历史最高分3.8分（满分4分）的惊人评价。</p>

<h3>情节：暧昧中的悬疑</h3>
<p>影片讲述了送货员钟秀（刘亚仁饰）偶然重逢儿时玩伴海美（全钟瑞饰），两人之间产生了微妙的情感。然而海美从非洲旅行归来时，身边多了一个神秘男子本（史蒂文·元饰）。本向钟秀透露了自己有一个奇怪的爱好——烧塑料大棚。此后，海美突然失踪，钟秀陷入了一场关于真相与幻觉的追寻。</p>

<h3>阶级隐喻：韩国社会的隐秘创伤</h3>
<p>李沧东巧妙地将韩国社会的阶级矛盾编织进悬疑叙事中。钟秀出身农村贫困家庭，住在临近朝鲜边境的破旧农舍；而本则是典型的江南区富家子弟，住在精致的高级公寓里。两人之间的张力不仅仅是情敌关系，更是韩国社会贫富差距的具象化呈现。本口中的"烧大棚"隐喻着特权阶级对底层人群的漠视和消解。</p>

<h3>存在主义追问</h3>
<p>影片中反复出现的饥饿意象——生理的饥饿与精神的饥饿——构成了对当代青年生存状态的诗意表达。海美在夕阳下脱下上衣跳舞的那场戏，被许多影评人视为21世纪电影史上最令人难忘的场景之一。那一刻，所有关于自由、孤独和存在边界的思考都凝聚在了全钟瑞舒展的肢体语言中。</p>`,
    category: '社会批判',
    categorySlug: 'social-critique',
    director: '李沧东',
    cast: ['刘亚仁', '全钟瑞', '史蒂文·元'],
    year: 2018,
    rating: 8.7,
    runtime: '148分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20arthouse%20film%20scene%20with%20a%20lonely%20young%20man%20standing%20near%20a%20rural%20greenhouse%20at%20twilight%2C%20hazy%20atmospheric%20lighting%2C%20minimalist%20composition%2C%20warm%20orange%20and%20deep%20shadow%20contrast%2C%20melancholic%20mood%2C%20cinematic%20photography%2C%20subtle%20grain%20texture&width=800&height=500&seq=burning-2018&orientation=landscape',
    tags: ['李沧东', '村上春树改编', '阶级', '悬疑', '戛纳'],
    featured: true,
    publishDate: '2024-09-28',
  },
  {
    id: '3',
    slug: 'obsessed-review',
    title: '《人间中毒》：禁忌之爱与战争创伤的交织',
    excerpt: '宋承宪突破性演出，以1969年越南战争尾声的韩国军队为背景，讲述了一段令人窒息的禁忌恋情。影片探讨了战争创伤与情感空虚如何驱使人们走向道德的灰色地带。',
    content: `<p>《人间中毒》（Obsessed）是2014年由金大佑导演执导的韩国爱情片，以1969年越南战争末期为背景，讲述了从战场归来的英雄上校金镇平（宋承宪饰）与下属的妻子钟佳欣（林智妍饰）之间发生的禁忌之恋。</p>

<h3>战争背景下的情感真空</h3>
<p>影片选择了一个独特的时代背景——越南战争。金镇平作为战争英雄，表面上拥有令人艳羡的一切：荣誉、地位、美丽的妻子。但战争的创伤和军队生活的压抑让他内心空洞。钟佳欣的出现如同一道光，照亮了他灰暗的生活。影片细腻地描绘了这种在极端环境下滋生的情感。</p>

<h3>视觉风格：复古美学的极致运用</h3>
<p>影片在美术设计上极为用心，1960年代末的军服、家居、街道都得到了精准还原。柔和的暖色调赋予画面一种怀旧感，与故事中压抑的情感形成微妙的对比。尤其是几场关键的情感戏，光影的运用达到了极高的艺术水准。</p>

<h3>演员突破</h3>
<p>宋承宪凭借此片实现了形象上的重大突破，摆脱了以往的偶像包袱。他将金镇平内心的挣扎——对妻子的责任、对军队纪律的服从与对钟佳欣无法抑制的渴望——表现得淋漓尽致。新人林智妍也凭借此片获得了广泛关注，她诠释的钟佳欣既有东方式的内敛，又有为爱义无反顾的勇气。</p>`,
    category: '禁忌爱情',
    categorySlug: 'forbidden-love',
    director: '金大佑',
    cast: ['宋承宪', '林智妍', '赵茹珍', '温朱万'],
    year: 2014,
    rating: 7.9,
    runtime: '132分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20period%20romance%20film%20scene%20set%20in%201960s%20military%20setting%2C%20a%20man%20and%20woman%20in%20vintage%20military%20uniform%20and%20elegant%20dress%20standing%20in%20a%20dimly%20lit%20corridor%2C%20warm%20amber%20cinematic%20lighting%2C%20nostalgic%20film%20aesthetic%2C%20intimate%20atmosphere%2C%20soft%20focus%20background&width=800&height=500&seq=obsessed-2014&orientation=landscape',
    tags: ['战争背景', '禁忌之恋', '1960年代', '宋承宪'],
    featured: false,
    publishDate: '2024-09-20',
  },
  {
    id: '4',
    slug: 'the-treacherous-review',
    title: '《奸臣》：权力游戏中的欲望与毁灭',
    excerpt: '以朝鲜燕山君时期为背景的历史剧情片，揭示了权力巅峰下人性最黑暗的深渊。影片通过对暴君燕山君荒淫无度生活的描绘，折射出权力对人性的腐蚀。',
    content: `<p>《奸臣》（The Treacherous）是2015年上映的韩国历史剧情片，由闵奎东导演执导，以朝鲜王朝最臭名昭著的暴君燕山君时期为背景，讲述了昏君与奸臣之间权力与欲望的博弈。</p>

<h3>历史背景：燕山君时代的政治黑暗</h3>
<p>燕山君（1494-1506年在位）是朝鲜王朝历史上最具争议的君主之一。影片聚焦于燕山君执政后期，他沉迷于女色和享乐，朝政被奸臣任士洪、任崇载父子把持。影片以大胆的笔触描绘了这一时期宫廷内部的权力斗争和道德沦丧。</p>

<h3>视觉冲击与历史还原</h3>
<p>影片在服装、道具和场景方面投入巨大，完美还原了朝鲜王朝的宫廷风貌。色彩运用大胆鲜明——红色的宫殿、金色的装饰、华丽的韩服——构成了一场视觉盛宴。但在这华丽的表象之下，是令人不寒而栗的人性黑暗。</p>

<h3>权力批判</h3>
<p>《奸臣》不仅仅是一部讲述宫廷艳史的电影，更是一部关于权力的寓言。影片通过燕山君和他的宠臣们之间的互动，展示了绝对权力如何一步步腐蚀人性。影片结尾的处理尤为震撼——当所有欲望都被满足后，留下的只有虚无和毁灭。</p>`,
    category: '经典回顾',
    categorySlug: 'classic',
    director: '闵奎东',
    cast: ['朱智勋', '金康宇', '林智妍', '千浩振'],
    year: 2015,
    rating: 7.6,
    runtime: '133分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20historical%20drama%20film%20scene%20set%20in%20Joseon%20dynasty%20palace%2C%20royal%20court%20with%20ornate%20traditional%20Korean%20costumes%20in%20red%20and%20gold%2C%20dramatic%20lighting%20with%20deep%20shadows%2C%20palace%20interior%20with%20intricate%20wooden%20details%2C%20cinematic%20composition%2C%20regal%20atmosphere&width=800&height=500&seq=treacherous-2015&orientation=landscape',
    tags: ['历史', '燕山君', '宫廷', '权力', '朝鲜王朝'],
    featured: false,
    publishDate: '2024-09-12',
  },
  {
    id: '5',
    slug: 'a-frozen-flower-review',
    title: '《霜花店》：忠诚与欲望的撕裂抉择',
    excerpt: '赵寅成与朱镇模主演的高丽末期宫廷情感大片。影片讲述了一段发生在高丽王、王后卫与侍卫队长之间的禁忌三角关系，探讨了忠诚、欲望与权力之间的复杂纠葛。',
    content: `<p>《霜花店》（A Frozen Flower）是2008年由柳河导演执导的韩国历史剧情片，以高丽王朝末期为背景，讲述了高丽王（朱镇模饰）、王后卫（宋智孝饰）和侍卫队长洪麟（赵寅成饰）之间纠缠不清的情感关系。</p>

<h3>独特的叙事视角</h3>
<p>影片以一个极具戏剧性的设定开场：高丽王深爱着自己的侍卫队长洪麟，但因王室需要子嗣继承王位，他命令洪麟代替自己与王后同房。这一决定引发了一系列不可控的情感变化，最终导致了悲剧性的结局。影片借此探讨了情感是否可以由理性来控制的深刻命题。</p>

<h3>视觉美学：冷艳的宫廷画卷</h3>
<p>影片的美术设计极具风格化，以冷色调为主，营造出一种高贵而压抑的氛围。尤其是宫殿内部的场景设计，大量运用了对称构图和纵深空间，象征着权力结构对个人情感的压制。几场情欲戏的拍摄在韩国电影中堪称大胆，但柳河导演的处理方式赋予了它们艺术性而非低俗感。</p>

<h3>演员阵容</h3>
<p>赵寅成在片中贡献了职业生涯中最具突破性的表演。他饰演的洪麟从最初的忠诚顺从，到后来的情感觉醒，再到最终的挣扎与反抗，每一个阶段都层次分明。朱镇模的高丽王则展现出君主身份与个人情感之间的矛盾，令人既同情又畏惧。</p>`,
    category: '禁忌爱情',
    categorySlug: 'forbidden-love',
    director: '柳河',
    cast: ['赵寅成', '朱镇模', '宋智孝', '沈智浩'],
    year: 2008,
    rating: 8.4,
    runtime: '133分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20historical%20romance%20film%20scene%20in%20Goryeo%20dynasty%20palace%2C%20two%20men%20in%20traditional%20warrior%20costumes%20and%20a%20woman%20in%20royal%20hanbok%2C%20cold%20blue%20and%20silver%20color%20palette%2C%20symmetrical%20composition%2C%20moonlight%20streaming%20through%20palace%20windows%2C%20melancholic%20atmosphere%2C%20elegant%20cinematography&width=800&height=500&seq=frozen-flower-2008&orientation=landscape',
    tags: ['高丽王朝', '三角关系', '宫廷', '悲剧'],
    featured: false,
    publishDate: '2024-09-05',
  },
  {
    id: '6',
    slug: 'portrait-of-a-beauty-review',
    title: '《美人图》：艺术、性别与欲望的边界探索',
    excerpt: '以朝鲜时代著名女画家申润福的传奇人生为蓝本，讲述了女扮男装成为宫廷画师的她，在艺术创作与个人情感之间的挣扎。影片对性别身份和艺术自由的探讨具有超前性。',
    content: `<p>《美人图》（Portrait of a Beauty）是2008年由田昀树导演执导的韩国历史剧情片，改编自韩国作家李正明的同名小说，以朝鲜时代最具传奇色彩的女画家申润福为原型，讲述了一个关于艺术、性别与欲望的故事。</p>

<h3>历史原型：申润福的传奇</h3>
<p>申润福（1758年-？）是朝鲜后期著名的风俗画家，以其大胆的题材和细腻的笔触闻名。影片在历史人物的基础上进行了艺术加工，讲述了申润福（金圭丽饰）女扮男装进入图画署（宫廷画院），在追求艺术理想的过程中，经历身份认同和情感纠葛的故事。</p>

<h3>艺术与欲望的交织</h3>
<p>影片最引人入胜的部分在于对"观看"这一行为的探讨。作为画师，申润福需要"观看"并以画笔"再现"世界。但当她需要绘制春宫图时，"观看"本身变成了一种欲望的表达。影片通过这一设定，巧妙地探讨了艺术创作与个人欲望之间不可分割的关系。</p>

<h3>性别身份的流动性</h3>
<p>《美人图》在性别议题上的处理具有相当的进步性。申润福的女扮男装不仅仅是一种生存策略，更成为她探索自我身份的一种方式。影片通过她的视角，质疑了传统社会对性别角色的刻板定义。这种对性别流动性的探讨，使影片超越了普通历史片的范畴。</p>`,
    category: '经典回顾',
    categorySlug: 'classic',
    director: '田昀树',
    cast: ['金圭丽', '金英浩', '秋瓷炫', '金南佶'],
    year: 2008,
    rating: 7.5,
    runtime: '116分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20period%20film%20about%20a%20female%20painter%20in%20Joseon%20dynasty%2C%20a%20woman%20dressed%20as%20a%20male%20scholar%20holding%20a%20paintbrush%20in%20a%20traditional%20Korean%20art%20studio%2C%20soft%20diffused%20natural%20light%2C%20ink%20wash%20painting%20aesthetic%2C%20elegant%20minimalist%20composition%2C%20warm%20cream%20and%20charcoal%20tones&width=800&height=500&seq=portrait-beauty-2008&orientation=landscape',
    tags: ['申润福', '女扮男装', '艺术', '朝鲜时代', '性别'],
    featured: false,
    publishDate: '2024-08-28',
  },
  {
    id: '7',
    slug: 'untold-scandal-review',
    title: '《丑闻》：朝鲜时代的危险关系',
    excerpt: '裴勇俊突破性出演，将法国经典小说《危险关系》移植到朝鲜时代。影片以精致的古典美学包装了一场关于诱惑、背叛和道德沦丧的华丽游戏。',
    content: `<p>《丑闻：朝鲜男女相悦之事》（Untold Scandal）是2003年由李在容导演执导的韩国历史剧情片，改编自法国作家拉克洛的经典书信体小说《危险关系》。影片将故事背景移植到18世纪末的朝鲜王朝，创造出一部兼具东西方美学魅力的作品。</p>

<h3>本土化改编的精妙之处</h3>
<p>将法国大革命前夕的贵族社交圈移植到朝鲜王朝后期，李在容导演展现了惊人的文化转换能力。原著的沙龙文化被转化为朝鲜士大夫的书房聚会，书信往来则变成了汉字书信和诗词唱和。这种改编不仅忠实于原著的精神内核，还赋予了故事全新的东方韵味。</p>

<h3>裴勇俊的转型之作</h3>
<p>本片是裴勇俊从电视剧偶像向电影演员转型的关键作品。他饰演的赵元是一个外表儒雅、内心冷酷的贵族浪子，以征服贞洁女性为乐。裴勇俊将角色的复杂心理——表面的温文尔雅与内心的阴暗欲望——演绎得层次分明，成功摆脱了"韩流明星"的标签。</p>

<h3>道德寓言</h3>
<p>影片表面上是一场关于诱惑与背叛的游戏，但深层来看是一部关于道德边界的寓言。赵元和赵氏夫人（李美淑饰）以操纵他人情感为乐，但当游戏失控时，他们自己也被卷入无法挽回的悲剧。影片以此警示：以他人的感情为游戏的代价，最终只能是自我毁灭。</p>`,
    category: '禁忌爱情',
    categorySlug: 'forbidden-love',
    director: '李在容',
    cast: ['裴勇俊', '李美淑', '全度妍', '赵显宰'],
    year: 2003,
    rating: 7.8,
    runtime: '124分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20period%20drama%20film%20scene%20with%20a%20nobleman%20and%20noblewoman%20in%20elaborate%20Joseon%20era%20silk%20hanbok%20facing%20each%20other%20in%20a%20traditional%20Korean%20garden%20with%20fall%20foliage%2C%20soft%20golden%20hour%20light%2C%20romantic%20yet%20melancholic%20atmosphere%2C%20classical%20composition&width=800&height=500&seq=untold-scandal-2003&orientation=landscape',
    tags: ['改编', '危险关系', '朝鲜时代', '裴勇俊'],
    featured: false,
    publishDate: '2024-08-20',
  },
  {
    id: '8',
    slug: 'eungyo-review',
    title: '《恩娇》：青春与衰老的诗意碰撞',
    excerpt: '朴海日与金高银主演的争议之作，讲述了一位年迈诗人与他的年轻女弟子之间超越伦理的情感羁绊。影片以唯美的画面和细腻的心理刻画探讨了创作灵感、青春崇拜与人性的幽暗面。',
    content: `<p>《恩娇》（Eungyo / A Muse）是2012年由郑址宇导演执导的韩国剧情片，改编自作家朴范信的同名小说。影片讲述了一位70岁的国民诗人李寂寥（朴海日饰）与17岁少女恩娇（金高银饰）之间发生的复杂情感故事。</p>

<h3>青春崇拜：老诗人的灵感源泉</h3>
<p>影片以李寂寥的视角展开。作为一位享誉全国的诗人，他步入晚年后创作力日渐枯竭。恩娇的出现如同一道闪电——她的青春、活力和纯真重新点燃了老诗人的创作欲望。但这份"灵感"逐渐超越了纯粹的艺术层面，演变成一种令他自己也感到不安的情感。</p>

<h3>金高银的惊艳出道</h3>
<p>《恩娇》是金高银的出道作品，她从300:1的激烈竞争中脱颖而出获得了恩娇这一角色。她在片中展现了远超年龄的演技成熟度——恩娇的天真与早熟、纯净与诱惑在她身上奇妙地共存。金高银凭借此片获得了包括大钟奖、青龙奖在内的多项新人奖。</p>

<h3>争议与深度</h3>
<p>影片因涉及老年男性与未成年少女之间的情感而引发巨大争议。但导演郑址宇的处理方式并非哗众取宠，而是真诚地探讨了一个深刻的话题：当创作者对"美"的追求与个人情感发生冲突时，艺术的边界在哪里？影片没有给出简单答案，而是将这一伦理困境完整地呈现给观众。</p>`,
    category: '禁忌爱情',
    categorySlug: 'forbidden-love',
    director: '郑址宇',
    cast: ['朴海日', '金高银', '金武烈'],
    year: 2012,
    rating: 7.7,
    runtime: '129分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20art%20film%20scene%20with%20a%20young%20woman%20in%20simple%20white%20dress%20standing%20in%20a%20sunlit%20traditional%20Korean%20house%20courtyard%2C%20an%20elderly%20man%20in%20the%20background%20watching%2C%20soft%20natural%20backlighting%2C%20poetic%20atmosphere%2C%20warm%20cream%20and%20soft%20green%20tones%2C%20contemplative%20mood&width=800&height=500&seq=eungyo-2012&orientation=landscape',
    tags: ['诗人', '忘年', '青春', '文学改编', '出道作'],
    featured: false,
    publishDate: '2024-08-15',
  },
  {
    id: '9',
    slug: 'scarlet-innocence-review',
    title: '《情欲诱惑》：现代版《沈清传》的黑暗变奏',
    excerpt: '郑雨盛与李絮主演的现代悬疑爱情片，将韩国古典小说《沈清传》改编为当代背景下的复仇故事。影片以欲望、欺骗和救赎为主线，探讨了人性的复杂面向。',
    content: `<p>《情欲诱惑》（Scarlet Innocence）是2014年由林弼成导演执导的韩国悬疑爱情片，郑雨盛和李絮主演。影片以现代视角重新诠释了韩国古典小说《沈清传》，创造出一个关于欲望、欺骗和复仇的黑暗故事。</p>

<h3>古典文学与现代叙事的融合</h3>
<p>《沈清传》是韩国最具代表性的古典小说之一，讲述了孝女沈清为救盲父而投身大海，最终获得幸福的故事。而《情欲诱惑》彻底颠覆了这一温情叙事——影片中的"沈清"（李絮饰）不再是单纯无辜的少女，而是一个带着明确目的的复仇者。这种颠覆性的改编赋予了古老故事全新的现实意义。</p>

<h3>欲望的连锁反应</h3>
<p>影片中，大学教授学奎（郑雨盛饰）在一次出差中与游乐场售票员德熙（李絮饰）发生了一段激情关系。八个月后，德熙以"沈清"的身份出现在学奎任教的大学，由此展开了一场精心策划的复仇。影片巧妙地揭示了每一个选择背后的欲望驱动——学奎的欲望、德熙的欲望、以及旁观者的欲望——构成了一张难以挣脱的网。</p>

<h3>视觉风格：冷峻中的暗涌</h3>
<p>影片采用冷色调贯穿始终，无论是冬季的乡村小镇还是城市的大学校园，都被笼罩在一种清冽的氛围中。这种视觉风格与人物内心的暗涌形成强烈对比，营造出一种持续的紧张感。尤其是几场关键对峙戏，林弼成导演的场面调度展现了极高的水准。</p>`,
    category: '悬疑惊悚',
    categorySlug: 'thriller',
    director: '林弼成',
    cast: ['郑雨盛', '李絮', '朴素英', '金希沅'],
    year: 2014,
    rating: 7.3,
    runtime: '113分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20film%20scene%20in%20a%20modern%20university%20campus%20setting%20during%20winter%2C%20a%20man%20and%20woman%20standing%20apart%20in%20a%20empty%20classroom%20with%20cold%20blue-grey%20tones%2C%20snow%20falling%20outside%20windows%2C%20tense%20atmosphere%2C%20minimalist%20composition%2C%20film%20noir%20influence&width=800&height=500&seq=scarlet-innocence-2014&orientation=landscape',
    tags: ['现代改编', '复仇', '沈清传', '校园'],
    featured: false,
    publishDate: '2024-08-08',
  },
  {
    id: '10',
    slug: 'the-servant-review',
    title: '《方子传》：底层视角下的经典重述',
    excerpt: '以《春香传》中男仆方子的视角重新演绎经典爱情故事。影片以独特的下人视角，揭示了阶级差异如何扭曲爱情与人性，是韩国古装伦理片中的另类佳作。',
    content: `<p>《方子传》（The Servant）是2010年由金大佑导演执导的韩国历史剧情片，以韩国最著名的古典爱情故事《春香传》为蓝本，但创造性地将叙述视角从传统的才子佳人转移到了男仆方子身上。</p>

<h3>视角转换的颠覆性</h3>
<p>在传统《春香传》中，故事围绕着贵族公子李梦龙与艺妓之女春香之间的爱情展开，方子仅仅是李梦龙身边一个不起眼的仆人。但在金大佑的版本中，方子（金柱赫饰）成为了故事的主角。这种视角的颠覆不仅仅是叙事技巧的创新，更是对阶级社会的一次犀利反思。</p>

<h3>欲望的阶级性</h3>
<p>影片通过方子的眼睛，揭示了一个残酷的现实：在等级森严的朝鲜社会，连"爱"的权力都被阶级所规定。方子对春香的感情，从一开始就被注定不会有好结果。影片中方子内心独白的运用，让观众深刻感受到一个底层人物在欲望与现实之间的挣扎。</p>

<h3>喜剧外壳下的悲剧内核</h3>
<p>《方子传》在叙事上采用了喜剧化的处理方式，金柱赫的表演带有一种黑色幽默的质感。但在这层喜剧外壳之下，隐藏的是一个关于阶级、尊严和人性的悲剧故事。影片结尾的处理尤其耐人寻味——方子最终的选择既是一种反抗，也是一种无奈的妥协。</p>`,
    category: '经典回顾',
    categorySlug: 'classic',
    director: '金大佑',
    cast: ['金柱赫', '赵茹珍', '柳承范', '柳贤京'],
    year: 2010,
    rating: 7.4,
    runtime: '124分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20period%20comedy-drama%20film%20scene%20with%20a%20male%20servant%20in%20traditional%20Korean%20commoner%20clothing%20peeking%20through%20a%20wooden%20gate%20at%20a%20traditional%20Korean%20village%2C%20warm%20earthy%20tones%2C%20rustic%20atmosphere%2C%20natural%20daylight%2C%20playful%20yet%20melancholic%20mood&width=800&height=500&seq=the-servant-2010&orientation=landscape',
    tags: ['春香传', '仆人视角', '阶级', '黑色幽默'],
    featured: false,
    publishDate: '2024-07-30',
  },
  {
    id: '11',
    slug: 'secret-sunshine-review',
    title: '《密阳》：全度妍的痛彻心扉与信仰叩问',
    excerpt: '李沧东导演又一力作，全度妍凭借此片获得戛纳影后。影片讲述了一位失去丈夫的年轻母亲带着儿子回到亡夫故乡密阳，经历人生最大悲剧后，在信仰与绝望之间挣扎的故事。',
    content: `<p>《密阳》（Secret Sunshine）是2007年由李沧东导演执导的韩国剧情片，全度妍和宋康昊主演。影片讲述了申爱（全度妍饰）在丈夫去世后，带着年幼的儿子从首尔搬到丈夫的故乡密阳，试图开始新生活，却遭遇了更大的悲剧。</p>

<h3>全度妍的封后之作</h3>
<p>全度妍在《密阳》中的表演被公认为韩国电影史上最杰出的女性表演之一。她饰演的申爱经历了丧夫之痛、丧子之痛、信仰的获得与幻灭——每一个情感阶段都被她以令人窒息的真实感呈现出来。全度妍凭借此片获得第60届戛纳电影节最佳女主角奖，成为韩国首位获此殊荣的演员。</p>

<h3>信仰与救赎的辩证</h3>
<p>影片的核心命题是关于信仰——当申爱在绝望中投向基督教寻求慰藉时，她似乎找到了继续生活的力量。但当她去监狱"宽恕"杀害儿子的凶手时，却被告知凶手已经"先一步被上帝原谅了"。这一场景的冲击力极其强烈，申爱的信仰在这一刻彻底崩溃。李沧东通过这一情节，对宗教信仰进行了深刻的叩问。</p>

<h3>密阳：地名与隐喻</h3>
<p>"密阳"在韩语中意为"秘密的阳光"。影片中，阳光反复出现——有时温暖，有时灼热，有时刺眼——成为申爱内心状态的外化象征。李沧东用这个普通的小城市作为舞台，揭示了日常生活中隐藏的深刻痛苦和人性的光芒。</p>`,
    category: '社会批判',
    categorySlug: 'social-critique',
    director: '李沧东',
    cast: ['全度妍', '宋康昊', '赵英镇', '金英在'],
    year: 2007,
    rating: 8.6,
    runtime: '142分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20drama%20film%20scene%20in%20a%20small%20rural%20town%2C%20a%20woman%20standing%20alone%20in%20an%20empty%20field%20under%20bright%20afternoon%20sunlight%2C%20melancholic%20atmosphere%2C%20naturalistic%20cinematography%2C%20warm%20golden%20and%20pale%20blue%20tones%2C%20contemplative%20mood%2C%20wide%20composition&width=800&height=500&seq=secret-sunshine-2007&orientation=landscape',
    tags: ['李沧东', '戛纳影后', '信仰', '悲剧', '全度妍'],
    featured: true,
    publishDate: '2024-07-22',
  },
  {
    id: '12',
    slug: 'two-women-review',
    title: '《两个女人》：婚姻围城中的情感博弈',
    excerpt: '以细腻的女性视角展现了一段婚外情中两个女人的心理较量。影片跳出了简单的道德判断，深入探讨了当代婚姻关系中的情感需求与人际博弈。',
    content: `<p>《两个女人》（Two Women）是2010年由郑允秀导演执导的韩国剧情片，讲述了大学教授的妻子素英（申恩庆饰）在发现丈夫与年轻女学生秀芝（郑俊镐饰）有染后，与这位"第三者"之间展开的一场微妙的情感博弈。</p>

<h3>反套路的叙事选择</h3>
<p>与大多数婚外情题材影片不同，《两个女人》没有简单地将"第三者"妖魔化或将"原配"神圣化。影片通过素英的视角，展现了她从发现出轨时的愤怒、到决定"了解对手"时的好奇、再到与秀芝建立某种微妙联系时的困惑。这种复杂的情感变化使影片超越了简单的道德说教。</p>

<h3>女性凝视</h3>
<p>影片最值得注意的成就是其独特的"女性凝视"视角。导演郑允秀身为女性，能够以男性导演难以企及的细腻感捕捉女性角色的心理波动。影片中大量运用了素英的主观镜头——她观察秀芝的方式、她审视自己婚姻的方式——构成了一套完整的女性视角叙事。</p>

<h3>当代婚姻的困境</h3>
<p>《两个女人》虽然以婚外情为切入口，但探讨的实际上是当代婚姻关系的普遍困境。影片中素英丈夫的出轨并非简单的道德败坏，而是在长期婚姻中情感需求得不到满足后的迷失。影片不提供简单的道德答案，而是诚实地呈现了人性的复杂和婚姻的艰难。</p>`,
    category: '社会批判',
    categorySlug: 'social-critique',
    director: '郑允秀',
    cast: ['申恩庆', '郑俊镐', '沈仁英', '崔在成'],
    year: 2010,
    rating: 7.2,
    runtime: '105分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20drama%20film%20scene%20with%20two%20women%20in%20their%20thirties%20sitting%20across%20each%20other%20in%20a%20modern%20Seoul%20cafe%20with%20large%20windows%2C%20rainy%20day%20outside%2C%20tense%20atmosphere%2C%20cool%20neutral%20tones%2C%20realistic%20lighting%2C%20intimate%20two-shot%20composition&width=800&height=500&seq=two-women-2010&orientation=landscape',
    tags: ['女性视角', '婚姻', '当代', '心理'],
    featured: false,
    publishDate: '2024-07-15',
  },
];

export const getFeaturedArticles = (): Article[] => articles.filter(a => a.featured);

export const getArticlesByCategory = (slug: string): Article[] => articles.filter(a => a.categorySlug === slug);

export const getArticleBySlug = (slug: string): Article | undefined => articles.find(a => a.slug === slug);

export const getRelatedArticles = (slug: string, count: number = 3): Article[] => {
  const article = getArticleBySlug(slug);
  if (!article) return [];
  return articles
    .filter(a => a.slug !== slug && a.categorySlug === article.categorySlug)
    .slice(0, count);
};